define('bizzabo/views/popup/ImportPartnersView',[
    'backbone',
    'underscore',
    'bizzabo/utils',
    'bizzabo/bzapi',
    'bizzabo/models/Global',
    'bizzabo/views/popup/PopupView',
    'bizzabo/views/UploadFileView',
    'hbars!bizzabo/templates/importPartners'
], function(
    Backbone,
    _,
    UTILS,
    BZAPI,
    Global,
    PopupView,
    UploadFileView,
    template
    ) {

    var ImportPartnersView = PopupView.extend({

        events : {
            'click .doneButton' : 'doneClicked',
            'click .close' : 'cancelClicked'
        },

        initialize : function() {
            this.popUpInitialize();

            var eventId = this.model.get('id') || 'new';
            this.partners = Global.modelPool.getPartners(eventId);

            // Create subviews
            this.uploadFileView = new UploadFileView({
                actionURL : '/organizer/partners/upload',
                fileAcceptType : '*',
                description : ' '
            });
            this.uploadFileView.on('success', this.sponsorsReceived, this);
        },

        remove : function() {
            this.uploadFileView.off('success', this.sponsorsReceived, this);
            this.uploadFileView.remove();
            this.$el.remove();
        },

        sponsorsReceived : function(jsonData) {
            this.$('.uploadPartnersFile').addClass('hide');
            this.$('.partnerProcessing').removeClass('hide');

            var thisView = this;
            var sponsors = UTILS.ensureArray(jsonData['event-partners']['sponsors']);
            var exhibitors = UTILS.ensureArray(jsonData['event-partners']['exhibitors']);
            var joined = sponsors.concat(exhibitors);

            var finishedProcessing = _.after(joined.length, function() {
                var sponsorsText = (sponsors.length == 1) ? 'sponsor' : 'sponsors';
                var exhibitorsText = (exhibitors.length == 1) ? 'exhibitor' : 'exhibitors';
                thisView.$('.partnerProgress').html('Successfully imported ' + sponsors.length + ' ' + sponsorsText + ' and ' + exhibitors.length + ' ' + exhibitorsText + '.');
                thisView.$('.loading').addClass('hide');
                thisView.$('.doneButton').removeClass('hide');

                thisView.partners.reset(joined);
                thisView.partners.validate();
            });

            var MAX_PARALLEL_SEND = 10;

            var processed = 0;
            var processedPartner = function() {
                processed++;
                thisView.$('.partnerProgress').html('Processing ' + processed + ' out of ' + joined.length + " event partners. Looks like it's going to be a great event!");
                processNext();
                finishedProcessing();
            };

            var processQueue = joined.concat();
            var processing = 0;
            var processNext = function() {
                if (processQueue.length == 0) {
                    return;
                }
                if (processing >= MAX_PARALLEL_SEND) {
                    return;
                }

                var partner = processQueue.shift();
                var logoURL = partner['logo-url'];
                if (logoURL && (logoURL.length > 0)) {
                    processing++;
                    BZAPI.replaceImageURL(logoURL, function(location) {
                        processing--;
                        partner['logo-url'] = location;
                        processedPartner();
                    }, function() {
                        processing--;
                        delete partner['logo-url'];
                        processedPartner();
                    });
                } else {
                    processedPartner();
                }

                processNext();
            };

            processNext();
        },

        // Actions

        cancelClicked : function() {
            this.hide();
        },

        doneClicked : function() {
            this.hide();
        },

        // Rendering

        render : function() {
            var html = template({});
            this.$el.html(html);
            this.$('.uploadFile').html(this.uploadFileView.render().el);
            return this;
        }
    });

    return ImportPartnersView;

});
